var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "inventory-item-history-sidesheet",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("files-viewer", { ref: "viewer" }),
      _c(
        "c-sidesheet",
        { attrs: { active: _vm.active }, on: { close: _vm.close } },
        [
          _c("div", { staticClass: "modal-frame" }, [
            _c(
              "div",
              { staticClass: "modal-wrapper" },
              [
                _c(
                  "shadow-scroll-container",
                  {
                    ref: "track",
                    staticClass: "modal-track",
                    attrs: { "with-top-scroller": true },
                  },
                  [
                    _c("div", { staticClass: "inventory-item-history" }, [
                      _c(
                        "div",
                        { staticClass: "inventory-item-history__wrapper" },
                        [
                          _c("div", { staticClass: "modal-frame__header" }, [
                            _c(
                              "h2",
                              { staticClass: "modal-frame__title" },
                              [
                                _vm.item
                                  ? [
                                      _vm._v(" История действий с ТМЦ "),
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-normal" },
                                        [
                                          _vm._v(
                                            "№" + _vm._s(_vm.item.serialNumber)
                                          ),
                                        ]
                                      ),
                                      _vm.item.name
                                        ? _c(
                                            "div",
                                            { staticClass: "item-name" },
                                            [_vm._v(_vm._s(_vm.item.name))]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                          _vm.loading
                            ? _c(
                                "div",
                                [
                                  _c("c-loader", {
                                    staticClass:
                                      "inventory-items-table__loading",
                                    attrs: {
                                      active: true,
                                      label: "Данные загружаются",
                                      height: 200,
                                    },
                                  }),
                                ],
                                1
                              )
                            : !_vm.items.length
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "inventory-items-table__empty",
                                  },
                                  [
                                    _vm._v(
                                      "Действий с ТМЦ пока не производилось"
                                    ),
                                  ]
                                ),
                              ])
                            : _c("div", [
                                _c("div", { staticClass: "lg" }, [
                                  _c("table", { staticClass: "h-table" }, [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [
                                          _c(
                                            "div",
                                            { staticClass: "h-table__header" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "h-table__col-title nowrap-title",
                                                },
                                                [_vm._v("Дата операции")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("th", [
                                          _c(
                                            "div",
                                            { staticClass: "h-table__header" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "h-table__col-title nowrap-title",
                                                },
                                                [_vm._v("Автор операции")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("th", [
                                          _c(
                                            "div",
                                            { staticClass: "h-table__header" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "h-table__col-title",
                                                },
                                                [_vm._v("Тип операции")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("th", [
                                          _c(
                                            "div",
                                            { staticClass: "h-table__header" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "h-table__col-title",
                                                },
                                                [_vm._v("Комментарий")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("th", [
                                          _c(
                                            "div",
                                            { staticClass: "h-table__header" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "h-table__col-title",
                                                },
                                                [_vm._v("Файлы")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.items, function (action) {
                                        return _c("tr", { key: action.id }, [
                                          _c("td", [
                                            _vm._v(
                                              " " + _vm._s(action.date) + " "
                                            ),
                                          ]),
                                          _c(
                                            "td",
                                            [
                                              action.actor
                                                ? _c("worker-or-user", {
                                                    attrs: {
                                                      value: action.actor,
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "td",
                                            [
                                              _vm._v(
                                                " " + _vm._s(action.type) + " "
                                              ),
                                              action.worker
                                                ? _c("worker-or-user", {
                                                    attrs: {
                                                      value: {
                                                        worker: action.worker,
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c("td", [
                                            _vm._v(
                                              " " +
                                                _vm._s(action.comment || "—") +
                                                " "
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "action-files",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showActionFiles(
                                                      action
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(action.filesText))]
                                            ),
                                          ]),
                                        ])
                                      }),
                                      0
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "sm" },
                                  [
                                    (!_vm.loading || _vm.page > 1) &&
                                    _vm.items.length
                                      ? _c(
                                          "horizontal-table",
                                          {
                                            on: {
                                              nextPage: function ($event) {
                                                return _vm.$emit("nextPage")
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "table",
                                              { staticClass: "h-table" },
                                              [
                                                _c("tbody", [
                                                  _c(
                                                    "tr",
                                                    [
                                                      _c("th", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "h-table__header",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "h-table__col-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Дата операции"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _vm._l(
                                                        _vm.items,
                                                        function (action) {
                                                          return _c(
                                                            "td",
                                                            { key: action.id },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    action.date
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                  _c(
                                                    "tr",
                                                    [
                                                      _c("th", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "h-table__header",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "h-table__col-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Автор операции"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _vm._l(
                                                        _vm.items,
                                                        function (action) {
                                                          return _c(
                                                            "td",
                                                            { key: action.id },
                                                            [
                                                              action.actor
                                                                ? _c(
                                                                    "worker-or-user",
                                                                    {
                                                                      attrs: {
                                                                        value:
                                                                          action.actor,
                                                                      },
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                  _c(
                                                    "tr",
                                                    [
                                                      _c("th", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "h-table__header",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "h-table__col-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Тип операции"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _vm._l(
                                                        _vm.items,
                                                        function (action) {
                                                          return _c(
                                                            "td",
                                                            { key: action.id },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    action.type
                                                                  ) +
                                                                  " "
                                                              ),
                                                              action.worker
                                                                ? _c(
                                                                    "worker-or-user",
                                                                    {
                                                                      attrs: {
                                                                        value: {
                                                                          worker:
                                                                            action.worker,
                                                                        },
                                                                      },
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                  _c(
                                                    "tr",
                                                    [
                                                      _c("th", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "h-table__header",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "h-table__col-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Комментарий"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _vm._l(
                                                        _vm.items,
                                                        function (action) {
                                                          return _c(
                                                            "td",
                                                            { key: action.id },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    action.comment ||
                                                                      "—"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                  _c(
                                                    "tr",
                                                    [
                                                      _c("th", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "h-table__header",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "h-table__col-title",
                                                              },
                                                              [_vm._v("Файлы")]
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _vm._l(
                                                        _vm.items,
                                                        function (action) {
                                                          return _c(
                                                            "td",
                                                            { key: action.id },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "action-files",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showActionFiles(
                                                                          action
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      action.filesText
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }